import { useMutation } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type {
  PostPointsOfDeliveryFilter,
  PostPointsOfDeliveryFilterParams,
} from "./apiEcms.types";

const postPointsOfDeliveryFilter = (
  payload: PostPointsOfDeliveryFilterParams,
) =>
  apiEcmsHttp.post<PostPointsOfDeliveryFilter>(
    "/points-of-delivery/filter",
    payload.inputsPayload,
    {
      params: {
        page: payload.paginationPayload.page,
        size: payload.paginationPayload.size,
      },
    },
  );

export const usePostPointsOfDeliveryFilter = () => {
  const { currentGroup } = useGroupReferences();

  return useMutation({
    mutationFn: postPointsOfDeliveryFilter,
    retry: false,
    mutationKey: [QUERY_KEYS.POINTS_OF_DELIVERY_FILTER, currentGroup],
  });
};
